export class BackendError extends Error{
    status_code: string | number;
    message: string;
    constructor(_status_code: string | number, _message: string) {
      super();
      this.status_code = _status_code;
      this.message = _message;
    }  
  }